import React from 'react';
import { Button, Popconfirm, Space, Tooltip } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import TrashIcon from 'assets/icons/trash.svg';
import PenIcon from 'assets/icons/pen.svg';
import type { Question } from '../types/Question';

type QuestionActionsProps = {
  question: Question;
  onClone: (id: number) => void | Promise<void>;
  onEdit: (question: Question) => void;
  onDelete: (id: number) => void | Promise<void>;
};

export default function QuestionActions({ question, onClone, onEdit, onDelete }: QuestionActionsProps) {
  const id = Number(question.id);
  if (!Number.isFinite(id)) {
    return null;
  }

  const hasFunctionTag = String(question.functionTag ?? '').trim().length > 0;

  return (
    <Space>
      <Tooltip title={hasFunctionTag ? 'Soruda fonksiyon etiketi dolu olduğu için kopyalanamaz.' : 'Kopyala'}>
        <span>
          <Button
            icon={<CopyOutlined />}
            shape="circle"
            onClick={() => void onClone(id)}
            className="icon-button"
            disabled={hasFunctionTag}
          />
        </span>
      </Tooltip>
      <Tooltip title='Düzenle'>
        <Button
          icon={<img src={PenIcon} alt="pen" className="icon" />}
          shape="circle"
          onClick={() => onEdit(question)}
          className="icon-button ml-12px"
        />
      </Tooltip>
      <Popconfirm title='Sil?' onConfirm={() => onDelete(id)}>
        <Tooltip title='Sil'>
          <Button
            icon={<img src={TrashIcon} alt="trash" className="icon" />}
            shape="circle"
            className="icon-button ml-12px"
          />
        </Tooltip>
      </Popconfirm>
    </Space>
  );
}
